const getErrorMessage = (payload, defaultMessage = 'An error occurred.') =>
  payload.detail || defaultMessage

export default getErrorMessage
